import {
  MAX_AUTO_REVIEW_RULES,
  useUserConfig,
  type AutoReviewRule,
  type AutoReviewRuleBehavior,
} from '@littlebird/sdk';

export const useAutoReviewRules = () => {
  const userConfig = useUserConfig();
  const rules = userConfig.autoReview.get('rules');
  const saveRules = (nextRules: AutoReviewRule[]) =>
    userConfig.autoReview.set('rules', nextRules);

  return {
    rules,
    canAddRule: rules.length < MAX_AUTO_REVIEW_RULES,
    addRule: (text: string, behavior: AutoReviewRuleBehavior) =>
      saveRules([
        ...rules,
        { id: crypto.randomUUID(), text: text.trim(), behavior },
      ]),
    updateRule: (
      ruleId: string,
      text: string,
      behavior: AutoReviewRuleBehavior
    ) =>
      saveRules(
        rules.map((rule) =>
          rule.id === ruleId ? { ...rule, text: text.trim(), behavior } : rule
        )
      ),
    removeRule: (ruleId: string) =>
      saveRules(rules.filter((rule) => rule.id !== ruleId)),
  };
};
